<template>
    <div class="content-view">
        <h2 class="fs-24 text-center fc-theme">淘宝客订单查询</h2>
        <p class="subtitle text-center fs-14 fc-666">根据淘宝后台检测订单是否为淘宝客订单，杜绝佣金损失</p>
        <p v-if="$store.state.phone" class="top-tip fc-333 fs-14 noborder">
            <i class="el-icon-s-opportunity"></i>
            <span>
            会员VIP每月免费使用<span class="fc-theme">{{pricePreMonth.vip_month_given_num}}</span> 次/月，<span>剩余免费<span class="fc-theme">{{pricePreMonth.surplus_given_num}}</span> 次，</span>
            会员VIP<span class="fc-theme">{{pricePreMonth.vip_point}}</span> 点券/次，非会员VIP<span class="fc-theme">{{pricePreMonth.point}}</span> 点券/次
            </span>
            <el-button v-if="!userData.is_vip" size="mini" type="danger" @click="$bus.emit('openVip', configData)">开通VIP</el-button>
        </p>
        <p v-else class="top-tip fc-333 fs-14 noborder">
            <i class="el-icon-s-opportunity"></i>
            <!-- <span>注册即可获得免费试用{{pricePreMonth.month_given_num}}次 <span v-if="!userData.is_vip" class="fc-theme point" @click="$bus.emit('openReg', configData)">点击注册</span></span> -->
            <span>新用户注册后可联系客服领取会员 <span v-if="!userData.is_vip" class="fc-theme point" @click="$bus.emit('openReg', configData)">点击注册</span></span>
        </p>

        <!-- <div v-if="$store.state.phone">
            <p style='font-size: 14px; color: #FF6464;'>因淘宝官方限制，该功能暂时无法使用，后期开放会通知</p>
        </div> -->

        <div class="flex marginT-20 paddingL-50">
            <el-button type="primary" @click="activeMarking = 'qr'" :plain="activeMarking == 'input'">扫码检测</el-button>
            <el-button class="marginL-20" type="primary" @click="activeMarking = 'input', qrInput = undefined, showQrResult = false" :plain="activeMarking == 'qr'">免扫码检测</el-button>
        </div>


        <div v-if="activeMarking == 'input'">
            <p class="marginT-50 fc-666">会员VIP用该方式消耗<span class="fc-theme">{{pricePreMonth.vip_point}}</span> 点券/次，非会员VIP<span class="fc-theme">{{pricePreMonth.point}}</span> 点券/次</p>
            <el-form class="marginT-20" label-width="100px" label-position="left">
                <el-form-item label="订单编号：">
                    <el-input
                        type="textarea"
                        :rows="8"
                        v-model="form.text"
                        placeholder="请输入淘宝订单编号，一行一个订单号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="onSubmit">提交查询</el-button>
                </el-form-item>
            </el-form>
            <div v-if="resultList.length > 0" class="query-record marginT-50">
                <el-card class="box-card flex-1 marginT-20">
                    <div slot="header" class="flex flex-between">
                        <span class="fw-bold fc-333">查询结果</span>
                        <!-- <span class="fc-theme fs-14">1分钟后自动刷新更新</span> -->
                    </div>
                    <div>
                        <div class="table">
                            <el-table :data="resultList" fit style="border: 1px solid #eee;">
                                <el-table-column prop="order_id" label="淘宝订单号"></el-table-column>
                                <el-table-column label="订单信息">
                                    <template slot-scope="scope">
                                        <div>
                                            <span v-if="scope.row.is_taobaoke == 1">因淘宝订单安全策略，订单明细无法显示。原价：未知，数量：未知，佣金比例：未知，收益人：未知。</span>
                                            <span class="fc-down" v-if="scope.row.is_taobaoke == 0">非淘宝客订单</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="是否淘宝客订单">
                                    <template slot-scope="scope">
                                        <span
                                            :class="scope.row.is_taobaoke == 0 ? 'fc-down' : 'fc-up'"
                                        >{{scope.row.is_taobaoke == 0 ? '非淘宝客订单号' : '是淘宝客订单号'}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
        <div v-else>
            <p class="marginT-50 fc-666">注册即可免费使用扫码检测</p>
            <p style='font-size: 14px; color: #FF6464; font-weight: 600;'>重要：扫码者必须是输入订单编号的掌柜旺旺号，否则无效</p>
            <el-form class="marginT-20" label-width="100px" label-position="left">
                <el-form-item label="订单编号：">
                    <el-input
                        v-model="qrInput"
                        placeholder="请输入淘宝订单编号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="onQrSubmit">点击生成二维码</el-button>
                </el-form-item>
            </el-form>
            <div v-show="showQrResult" class="marginT-20 text-center marginB-100">
                <p class="fc-333">请打开自己的手淘，进行扫码查看检测结果</p>
                <div class="qrcode marginT-20 flex flex-center" ref="qrcode" id="qrcode"></div>
            </div>
        </div>
        <el-card class="box-card tip-card">
            <div slot="header" class="clearfix">
                <el-tabs v-model="activeTip">
                    <el-tab-pane label="淘宝客订单检测"></el-tab-pane>
                </el-tabs>
            </div>
            <div>
                <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                <div class="content fs-14 fc-666">
                    订单检测扫码后不能查询的解决办法：<br>
                    1、用当前登陆手机淘宝的淘宝账号，登陆一次阿里妈妈<br>
                    2、阿里妈妈网址：www.alimama.com<br>
                    3、然后返回重新扫码即可
                    <!-- 1、输入交易的订单编号，即可查询该订单是否为淘宝客订单。<br>
                    2、根据淘宝官方的后台数据，进行检测，数据真实且有效。<br>
                    3、有效防止佣金损失，降低商家做单成本，避免买家拿走两倍佣金的情况。<br>
                    4、可选择扫码检测或免扫码检测。如果是扫码检测，手机淘宝扫码即可，页面提示“淘宝订单号输入有误”或“该淘宝订单未通过淘宝客推广链接下单”等字样，即为非淘客订单。<br>
                    如果是免扫码检测，页面下方会有查询结果。 -->
                </div>
                <div class="title marginT-10 fc-theme fs-18">消费说明</div>
                <div class="content fs-14 fc-666">
                    免扫码每查询一次，会员{{pricePreMonth.vip_point == 0 ? '免费使用' : `${pricePreMonth.vip_point}点券/次`}}，点此<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>。非会员{{pricePreMonth.point}}点券/次，扫码检测免费。<br>
                    点券值不足，如果查询的订单量大，建议先进行充值。<br>
                    接口合作请加微信{{getkfWx()}}
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import appConfig from '../mixin/appConfig';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            activeMarking: 'qr',
            qrInput: undefined,
            showQrResult: false,
            pricePreMonth: {},
            form: {
                text: ''
            },
            resultList: []
        }
    },
    mixins: [appConfig],
    computed: mapState(['userData', 'phone']),
    methods: {
        async checkOrder(no) {
            const data = await this.$fetch('/tool/accounts/item-order', { order_id: no })
            if (data.code == 0) {
                this.resultList.push({ order_id: no, is_taobaoke: data.data.is_taobaoke })
            }
        },
        async priceLimit() {
            const data = await this.$fetch('/tool/apps/api-info', {name: 'itemorder'})
            if (data && data.data) {
                this.pricePreMonth = data.data
            }
        },
        offShelfDialog() {
            this.$alert('由于淘宝规则变动，该功能暂处于维护中，恢复时间另行通知', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
            });
        },
        onQrSubmit() {
            // this.offShelfDialog();
            // return false;

            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            window.checkDiscountPackage("itemorder")

            this.qrInput = this.qrInput.replace(/ /g, '')
            if (this.qrInput.length == 0) {
                this.$message.error('请正确输入订单编号')
                this.$refs.qrcode.innerHTML = ''
                this.showQrResult = false
                return
            }
            if(!(/^\d+$/.test(this.qrInput))) {
                this.$message.error('请输入正确订单号')
                this.$refs.qrcode.innerHTML = ''
                this.showQrResult = false
                return
            }
            this.showQrResult = true
            const static_url = 'https://mos.m.taobao.com/union/query_cps_result?tbTradeParentId='
            let qrUrl = `${static_url}${this.qrInput}`
            this.qrcode(qrUrl)
        },
        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            let qrcode = new QRCode('qrcode', {
                width: 200,
                height: 200,
                text: data,
                correctLevel: 3,
            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100);
        },
        async onSubmit() {
            this.offShelfDialog();
            return false;


            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            window.checkDiscountPackage("itemorder")
            this.form.text = this.form.text.replace(/ /g, '')
            if (!this.form.text) {
                this.$message.error('请填写订单号')
                return
            }
            this.resultList = []
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.5)'
            })
            const list = this.form.text.split('\n')
            for (const key in list) {
                await this.checkOrder(list[key])
            }
            loading.close()
            this.activeMarking = 'qr'
            this.qrInput = list[0]
        }
    },
    mounted () {
        this.priceLimit()
    },
    watch: {
        phone(newValue) {
            if (newValue) {
                this.priceLimit()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content-view {
    .el-button--primary.is-plain:hover {
        background: #ecf5ff;
        border-color: #409EFF;
        color: #409EFF;
    }
}
</style>
